import React, { Component } from 'react'
import { Table, Button } from 'react-bootstrap';
import config from '../../config'
import Mensajes from '../subcomponent/mensajes';
import Menu from '../menu'
import { Fragment } from 'react';


export class cierreTurno extends Component {
    constructor(props) {
        super(props)
        const currentCompany = sessionStorage.getItem('company');
        //const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            mostrarMensaje: false,
            mensaje: "",
            empresa: currentCompany,
            infoReporte: [],
            infoValor: [],
            infoItems: [],
            totalItems: [],
            infoRange: []
        }
    }

    componentDidMount() {
        const { search } = this.props.location;
        const id_turno = search.replace('?', '');
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/reports/closeshift/' + id_turno, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    this.setState({
                        infoReporte: datos[0][0],
                        infoItems: datos[0],
                        infoValor: datos[1],
                        infoRange: datos[2]
                    })
                    this.totalesItem();
                    this.totalesValor();
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: data.message })
                }
            });
    }

    impresionPDF = (id) => {
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'blob',
                'empresa': this.state.empresa
            }
        }
        fetch(config.servBackEnd + '/shift/getpdf/' + id, datasend)
            .then((res) => {
                if (res.ok) return res.blob();
            }).then(function (myBlob) {
                var objectURL = URL.createObjectURL(myBlob);
                document.querySelector('#pdf-frame').src = '';
                document.querySelector('#pdf-frame').src = objectURL;
                objectURL = URL.revokeObjectURL(myBlob);
            }).then(
                function () {
                    window.setTimeout(function () {
                        document.querySelector('#pdf-frame').contentWindow.print();
                    }, 1000)
                })
            .catch((err) => {
                console.error(err);
            })
    }

    totalesItem = () => {
        const { infoItems } = this.state;
        let cantidad_total = 0;
        let bruto_total = 0;
        let iva_total = 0;
        let total_total = 0
        infoItems.forEach(element => {
            cantidad_total += element.CANTIDAD_1;
            bruto_total += element.TOTAL_BRUTO_DETALLE;
            iva_total += element.IVA_DETALLE;
            total_total += element.TOTAL_BRUTO_DETALLE + element.IVA_DETALLE;
        });
        const newTotalItems = {
            cantidad_total,
            bruto_total,
            iva_total,
            total_total
        }
        this.setState({ totalItems: newTotalItems });
    }

    totalesValor = () => {
        const informacionCabecera = this.state.infoReporte;
        const newinfoValor = this.state.infoValor;
        const { totalItems } = this.state;
        let pago_dirente_efectivo = 0;

        newinfoValor.forEach(pago => {
            if (pago.ID_METODO_PAGO !== 1) {
                pago_dirente_efectivo += parseInt(pago.VALOR, 10);
            }
        });

        newinfoValor.forEach(element => {
            if (element.ID_METODO_PAGO === 1) {
                element.VALOR = totalItems.total_total + informacionCabecera.BASE - pago_dirente_efectivo;
            }
        });


        this.setState({ infoValor: newinfoValor });
    }

    render() {
        const informacionCabecera = this.state.infoReporte;
        const { infoValor } = this.state;
        const { infoItems } = this.state;
        const { totalItems } = this.state;
        const { infoRange } = this.state;
        return (
            <div>
                <Menu></Menu>
                {totalItems.total_total &&
                    <Fragment>
                        <iframe id="pdf-frame"></iframe>
                        <Button onClick={() => this.impresionPDF(informacionCabecera.ID_TURNO)} >Impimir Tirilla </Button>
                        <Table striped bordered hover className="mt-3">
                            <tbody>
                                <tr>
                                    <th>NOMBRE VENDEDOR</th>
                                    <th>{informacionCabecera.VENDEDOR}</th>
                                </tr>
                                <tr>
                                    <th>FECHA DE INICIO</th>
                                    <th>{informacionCabecera.FECHA_APERTURA}</th>
                                </tr>
                                <tr>
                                    <th>FECHA DE FIN</th>
                                    <th>{informacionCabecera.FECHA_CIERRE}</th>
                                </tr>
                                {infoRange.map((element, i) => {
                                    return(
                                    <Fragment key={'num'+i}>
                                        <tr>
                                            <th>DOCUMENTO INICIAL</th>
                                            <th>{element.PREFIJO_DIAN + "-" + element.NUMERO_INICIO}</th>
                                        </tr>
                                        <tr>
                                            <th>DOCUMENTO FINAL</th>
                                            <th>{element.PREFIJO_DIAN + "-" + element.NUMERO_FINAL}</th>
                                        </tr>
                                    </Fragment>);
                                })}
                                <tr>
                                    <th>BASE</th>
                                    <th>{informacionCabecera.BASE}</th>
                                </tr>
                                <tr>
                                    <th>RECAUDADO</th>
                                    <th>{totalItems.total_total}</th>
                                </tr>
                                <tr>
                                    <th>TOTAL</th>
                                    <th>{parseInt(totalItems.total_total, 10) + parseInt(informacionCabecera.BASE, 10)}</th>
                                </tr>
                            </tbody>
                        </Table>
                        <Table striped bordered hover className="mt-3">
                            <thead>
                                <tr>
                                    <th colSpan="2">CUADRE</th>
                                </tr>
                                <tr>
                                    <th>METODO</th>
                                    <th>RECAUDO</th>
                                </tr>
                            </thead>
                            <tbody>
                                {infoValor.map((valor, i) => {
                                    return (
                                        <tr key={'tr' + i}>
                                            <td key={'td0' + i}>{valor.DESCRIPCION_METODO_PAGO}</td>
                                            <td key={'td1' + i}>{valor.VALOR}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>

                            </tfoot>
                        </Table>
                        <Table striped bordered hover className="mt-3">
                            <thead>
                                <tr>
                                    <th>ITEM</th>
                                    <th>CANTIDAD TOTAL</th>
                                    <th>VALOR BRUTO</th>
                                    <th>VALOR IVA</th>
                                    <th>VALOR TOTAL</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    infoItems.map((element, i) => {
                                        return (
                                            <tr key={'tr' + i}>
                                                <td key={'td1' + i}>{element.ITEM_DESCRIPCION}</td>
                                                <td key={'td2' + i}>{element.CANTIDAD_1}</td>
                                                <td key={'td3' + i}>{element.TOTAL_BRUTO_DETALLE}</td>
                                                <td key={'td4' + i}>{element.IVA_DETALLE}</td>
                                                <td key={'td5' + i}>{element.TOTAL_BRUTO_DETALLE + element.IVA_DETALLE}</td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td></td>
                                    <td>{totalItems.cantidad_total}</td>
                                    <td>{totalItems.bruto_total}</td>
                                    <td>{totalItems.iva_total}</td>
                                    <td>{totalItems.total_total}</td>
                                </tr>
                            </tfoot>
                        </Table>

                    </Fragment>
                }
                {
                    !totalItems.total_total &&
                    <h3>El Turno no tiene movimientos</h3>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div >
        )
    }
}

export default cierreTurno
